import React from 'react';
import classnames from 'classnames';
import './index.scss';
import RenderGameIcon from '@op/components/RenderImg/renderGameIcon';
import { useGameOperations } from '@op/utils/game';
import SvgIcon from '@home/components/SvgIcon';
import { useIntl } from 'umi';
import moment from 'moment';
import BubbleCommon, {
  compareGameNameClickTips,
} from '@op/components/BubbleCommon';

type TableColumnProps = {
  className?: string;
  name: string;
  item?: any;
  isCurrentGame?: boolean;
  showPlatform?: boolean;
  showReleaseDate?: boolean;
  extraContent?: React.ReactNode;
};

const TableColumn = (props: TableColumnProps) => {
  const {
    className,
    item,
    name,
    isCurrentGame,
    showPlatform = false,
    showReleaseDate = false,
    extraContent,
  } = props;

  const { handleChangeGame } = useGameOperations();
  const { formatMessage } = useIntl();

  return (
    <div className={classnames('dbo-compare-key-metrics-column', className)}>
      <RenderGameIcon gameInfo={item} className="game-icon"></RenderGameIcon>
      <div className={'game-data'}>
        <BubbleCommon placement='top' showIcon={false} tipsMap={compareGameNameClickTips}>
          <span
            onClick={(e) => {
              e.stopPropagation();
              handleChangeGame(item, true);
            }}
            className={classnames('game-name', {
              'game-name__current': isCurrentGame,
            })}
          >
            {name}
          </span>
        </BubbleCommon>
        {(showPlatform || showReleaseDate) && (
          <div className={'game-details'}>
            {showPlatform && item?.entity_type && (
              <>
                {item.entity_type.includes('mobile') && (
                  <SvgIcon className="game-platform-icon" type={'other-icon'} />
                )}
                {item.entity_type.includes('pc') && (
                  <SvgIcon className="game-platform-icon" type={'monitor'} />
                )}
                {item.entity_type.includes('console') && (
                  <SvgIcon className="game-platform-icon" type={'merit'} />
                )}
              </>
            )}
            {showReleaseDate && (
              <span
                className={classnames(
                  'game-release-date',
                  'game-release-date__border',
                )}
              >
                {item?.release_time
                  ? `${formatMessage({ id: 'Release Date' })}: ${moment(
                      item.release_time,
                    ).format('YYYY-MM-DD')}`
                  : formatMessage({ id: 'Unreleased' })}
              </span>
            )}
          </div>
        )}
        {extraContent}
      </div>
    </div>
  );
};

export default TableColumn;
